import { apiFetch } from './client';
import type { Lead, Paginated } from '$lib/types';

export type LeadListParams = Record<string, string | number | undefined>;

function toQuery(params: LeadListParams = {}): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') search.set(key, String(value));
  }
  const s = search.toString();
  return s ? `?${s}` : '';
}

export const leadsApi = {
  create: (body: Record<string, unknown>) => apiFetch<Lead>('/leads', { method: 'POST', body: JSON.stringify(body) }),
  issue: (id: number, body: Record<string, unknown>) => apiFetch<{ lead: Lead; issue_id: number }>(`/leads/${id}/issue`, { method: 'POST', body: JSON.stringify(body) }),
  list: (params?: LeadListParams) => apiFetch<Paginated<Lead>>(`/leads${toQuery(params)}`),
  get: (id: number) => apiFetch<Lead>(`/leads/${id}`),
  update: (id: number, body: Record<string, unknown>) =>
    apiFetch<Lead>(`/leads/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  resend: (id: number) => apiFetch<Lead>(`/leads/${id}/resend`, { method: 'POST' }),
  convert: (id: number, body: Record<string, unknown>) =>
    apiFetch<{ lead: Lead; person_id: number; company_id: number | null }>(`/leads/${id}/convert`, {
      method: 'POST',
      body: JSON.stringify(body)
    })
};
